// src/hooks/jobVouchers/useGetJobVoucher.js
import { useQuery } from "@tanstack/react-query";
import { getJobVoucher } from "../../api/apiJobVouchers";

const useGetJobVoucher = (jobVoucherId, options = {}) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["job-voucher", jobVoucherId],
        queryFn: () => getJobVoucher(jobVoucherId),
        enabled: !!jobVoucherId && (options.enabled !== false),
    });

    return {
        jobVoucher: data?.data || data || null,
        error,
        isLoading,
        refetch
    };
};

export default useGetJobVoucher;

